import 'UI/Widget/Base'
import 'System/Periodical'
import 'ServerTime.js'

/** @namespace Glonass.UI */
NS("Glonass.UI");

/**
 * @class
 * @extends UI.Widget.Base
 */
Glonass.UI.Header = Class(UI.Widget.Base, /** @lends Glonass.UI.Header.prototype */ {
    template: "Glonass/Header",

    timePeriodical: null,

    $serverTime: null,

    initialize: function() {
        var self = this;

        this.ParentCall();

        this.timePeriodical = new System.Periodical(function(callback) {
            self.updateServerTime();

            callback();
        }).start(10000);

        application.security.context.on("update", this.onContextUpdate, this);
    },

    destroy: function() {
        application.security.context.off("update", this.onContextUpdate, this);

        return this.ParentCall();
    },

    render: function() {
        this.ParentCall();

        this.$serverTime = this.$name("serverTime");

        this.updateServerTime();
        this.updateVersion();
        this.updateUserName();

        return this;
    },

    updateServerTime: function() {
        if (this.$serverTime) {
            this.$serverTime.text(ServerTime.date().format("d mmmm yyyy HH:MM"));
        }
    },

    updateVersion: function() {
        var self = this;

        Xhr.request('version', function (version) {
            self.$name("version").text(version);
        });
    },

    updateUserName: function() {
        try {
            this.$name("userName").text(Util.String.coalesce(context("user.name"), context("user.login")));
        } catch (e) {
            console.log(e);
        }
    },

    onHomeClick: function() {
        this.emit("homeClick");
    },

    onExitClick: function() {
        if (confirm("Действительно выйти из системы?")) {
            application.logout().then(() => window.location.replace('/'))
        }
    },

    onContextUpdate: function() {
        this.updateUserName();
    }
});
